// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.flex_ZMYVU {
  display : -webkit-box;
  display : -ms-flexbox;
  display : flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
      -ms-flex-direction: row;
          flex-direction: row;
  -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
  -webkit-box-align : center;
      -ms-flex-align : center;
          align-items : center;
  padding: 4px;
}
.flex_ZMYVU > * {
  margin : 4px;
}


.flex_ZMYVU.flex-space_bwu3l > * {
  margin : 8px;
}

.flex_ZMYVU.flex-noSpace_DEQK5 {
  padding : 0;
}
.flex_ZMYVU.flex-noSpace_DEQK5 > * {
  margin : 0;
}
.flex_ZMYVU.flex-noSpace_DEQK5 > *:first-child {
  /*background: black;
  flex : 1 1 auto;*/
}


.flex_ZMYVU.flex-hSpace_X_KOb {
  padding : 0 4px;
}
.flex_ZMYVU.flex-hSpace_X_KOb > * {
  margin : 0 4px 0 0;
}

.flex_ZMYVU.flex-hSpace_X_KOb > *:last-child {
  margin-right: 0
}


.flex_ZMYVU.flex-vSpace_S6Ggm {
  padding: 4px 0;

  /*flex-direction:column;*/
}
.flex_ZMYVU.flex-vSpace_S6Ggm > * {
  margin : 4px 0 4px 0;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/theme/Flex.css"],"names":[],"mappings":";AACA;EACE,qBAAc;EAAd,qBAAc;EAAd,cAAc;EACd,8BAAmB;EAAnB,6BAAmB;MAAnB,uBAAmB;UAAnB,mBAAmB;EACnB,qBAAiB;MAAjB,iBAAiB;EACjB,0BAAoB;MAApB,uBAAoB;UAApB,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,YAAY;AACd;;;AAGA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE;mBACiB;AACnB;;;AAGA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE;AACF;;;AAGA;EACE,cAAc;;EAEd,yBAAyB;AAC3B;AACA;EACE,oBAAoB;AACtB","sourcesContent":["\n.flex {\n  display : flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items : center;\n  padding: 4px;\n}\n.flex > * {\n  margin : 4px;\n}\n\n\n.flex.flex-space > * {\n  margin : 8px;\n}\n\n.flex.flex-noSpace {\n  padding : 0;\n}\n.flex.flex-noSpace > * {\n  margin : 0;\n}\n.flex.flex-noSpace > *:first-child {\n  /*background: black;\n  flex : 1 1 auto;*/\n}\n\n\n.flex.flex-hSpace {\n  padding : 0 4px;\n}\n.flex.flex-hSpace > * {\n  margin : 0 4px 0 0;\n}\n\n.flex.flex-hSpace > *:last-child {\n  margin-right: 0\n}\n\n\n.flex.flex-vSpace {\n  padding: 4px 0;\n\n  /*flex-direction:column;*/\n}\n.flex.flex-vSpace > * {\n  margin : 4px 0 4px 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flex": `flex_ZMYVU`,
	"flex-space": `flex-space_bwu3l`,
	"flex-noSpace": `flex-noSpace_DEQK5`,
	"flex-hSpace": `flex-hSpace_X_KOb`,
	"flex-vSpace": `flex-vSpace_S6Ggm`
};
export default ___CSS_LOADER_EXPORT___;
